import { WebGivingViewModel } from './webgiving-generated';
import { WebGivingMain } from './main/webgiving-main';
import { getWebGivingDataService } from './webgiving-data-service';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import moment from 'moment';
import { configure } from 'mobx';
import { WebGivingMainViewModel } from './main/webgiving-main-view-model';
import { GoogleAnalyticsWrapper } from './infrastructure/google-analytics-wrapper';
import { AjaxUtils } from '../Shared/utils/ajax-utils';
import './utils/hover-on-touch-fix';
import 'moment/locale/es';
import { scrollToTopOnRefresh } from '../Shared/utils/scroll-to-top';
import { initTranslation } from './translation';
// Delete export when removing Features.DisablePageLoadStats
export { send as sendPageLoadingStats } from '../Shared/utils/page-loading-stats';
moment.locale('en') // Sets default locale

configure({ enforceActions: true });
let disableValidation = false;

function initApp(model: WebGivingViewModel) {
	GoogleAnalyticsWrapper.initialize('WebGiving');
	const { MerchantInfo, UIConfiguration } = model;

	if (MerchantInfo.IsEntitledToLanguageSelector) {
		// Force english translation when hiding i18n toggle
		const defaultToEnglish = NewFeatures.SunsetFastpay && UIConfiguration && UIConfiguration.HideI18n;
		initTranslation(Boolean(defaultToEnglish));
	}

	const vm = new WebGivingMainViewModel(model, disableValidation);
	if (NewFeatures.WebGivingStateMachine) {
		throw new Error('Web Giving State Machine Not implemented');
	} else {
		ReactDOM.render(React.createElement(WebGivingMain, { vm }), document.getElementById('react-container'));
		scrollToTopOnRefresh();
	}

	// temporary to have the service testable from Chrome DevTools
	if (DEBUG) {
		(window as any)['dataService'] = getWebGivingDataService();
		(window as any)['vm'] = vm;
	}
}

export function init(model: string) {
	initApp(parseModelJSON(model));
}

declare let System: any;
export function initInDemoMode(m: string) {
	disableValidation = true;

	const model = parseModelJSON(m);

	if(NewFeatures.FixDemoMode) {
		window.pushpay.webgiving_demo.init(model);
		initApp(model);
	} else {
		System.import(/* webpackChunkName: "demo-mode" */ './demo-mode/init-demo.ts').then((module: any) => {
			module.init(model);
			initApp(model);
		});
	}
}

function parseModelJSON(model: string): WebGivingViewModel {
	return JSON.parse(model, AjaxUtils.reviveDate);
}
